module.exports = __webpack_public_path__ + "static/media/public-sector-square2.07410c42.jpg";